import { bl_alg_cc_qc_monthly_line_RowClass } from "../../../../dbschema";
import { BaseContainerModel } from "../../../base-container.model";

export class QualityControlMonthlyLineContainerModel extends BaseContainerModel {
    bl_alg_cc_qc_monthly_line: bl_alg_cc_qc_monthly_line_RowClass = new bl_alg_cc_qc_monthly_line_RowClass()
}
  